<template>
    <div
        v-show="!props.hide"
        :class="`uuid-${config.uuid}`"
        v-bind="props.attrs"
    >
        {{ i18n(props.text) || i18nLabel }}
    </div>
</template>
<script>

import ComponentBase from '../component-base';
import { component } from './props';
export default {
    name: component,
    extends: ComponentBase,
};
</script>

<style lang="less" scoped>
.mobile-general-form-node-text {
    padding: 20px 10px 10px;
    line-height: 17.5px;
    color: #777;
    font-size: 15px;
    align-self: center;
    align-items: center;
    display: flex;
}
</style>
